/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientNoteResponse
 */
export interface ClientNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientNoteResponse
     */
    note: string | null;
}

/**
 * Check if a given object implements the ClientNoteResponse interface.
 */
export function instanceOfClientNoteResponse(value: object): value is ClientNoteResponse {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function ClientNoteResponseFromJSON(json: any): ClientNoteResponse {
    return ClientNoteResponseFromJSONTyped(json, false);
}

export function ClientNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function ClientNoteResponseToJSON(json: any): ClientNoteResponse {
    return ClientNoteResponseToJSONTyped(json, false);
}

export function ClientNoteResponseToJSONTyped(value?: ClientNoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

